import { cn } from '@/lib/utils';
import { icons } from 'lucide-react';
import { memo } from 'react';

export type IconProps = {
  name: keyof typeof icons;
  className?: string;
  strokeWidth?: number;
};

export const Icon = memo(({ name, className, strokeWidth }: IconProps) => {
  const IconComponent = icons[name];

  if (!IconComponent) {
    // Fallback para ícones que não existem - usar um ícone genérico
    const FallbackIcon = icons['Image'] || icons['File'];
    if (!FallbackIcon) {
      return null;
    }
    return (
      <FallbackIcon
        className={cn('w-4 h-4', className)}
        strokeWidth={strokeWidth || 2.5}
      />
    );
  }

  return (
    <IconComponent
      className={cn('w-4 h-4', className)}
      strokeWidth={strokeWidth || 2.5}
    />
  );
});

Icon.displayName = 'Icon';
